module.exports = __webpack_public_path__ + "d6461379d5b58b3fe0078616e7a8575c.png";